import React from "react";
import { Combo } from "../../common/components/comboBox";
import { ModelloClimaDto } from "../../generated";
import { formGroup } from "../../common/components/formGroup";
import { ModelliClimaByMarcaStore } from "../ModelliClimaStore";
import { Loading } from "../../common/components/loading";

const Combobox = Combo<ModelloClimaDto>();
interface Props {
    marca: string;
    value: number | null,
    onChange: (type: ModelloClimaDto | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
const __ModelliClimaSelector = ({ onChange, value, error, label, onBlur, onFocus, marca }: Props) => {
    const data = ModelliClimaByMarcaStore.useMarca(marca);
    if (!data)
        return <Loading />

    return <Combobox
        label={label ?? "Caldaia"}
        allowNull
        data={data.filter(caldaia => caldaia.marca == marca)}
        textField={x => x.modello ?? ""}
        onSelect={x => onChange(x ?? null)}
        value={data.find(caldaia => caldaia.id == value) ?? null}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
    />;
}
export const ModelliClimaSelector = formGroup(__ModelliClimaSelector);